export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑面料',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ fabricStatus, approvalStatus }) => !['Q'].includes(fabricStatus) || ['P'].includes(approvalStatus),
  },
  {
    text: that.$l('menu_text_copy') || '复制面料',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'M',
  },
  {
    text: that.$l('menu_text_delete') || '删除面料',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    disabled: ({ fabricStatus, approvalStatus }) => !['Q'].includes(fabricStatus) || ['P'].includes(approvalStatus),
  },
  {
    text: that.$l('menu_text_recovery') || '恢复面料',
    icon: 'el-icon-refresh-left',
    menuType: 'recovery',
    allow: 'R',
    disabled: ({ fabricStatus }) => !['N'].includes(fabricStatus),
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-circle-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ fabricStatus, approvalStatus }) => !['Q'].includes(fabricStatus) || ['P'].includes(approvalStatus),
  },
]
